import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

interface RoleModalProps {
  isOpen: boolean;
  toggle: () => void;
  // roles: string[];
  selectedRole: string;
  onRoleChange: (newRole: string) => void;
}

export const RoleModal: React.FC<RoleModalProps> = ({
  isOpen,
  toggle,
  // roles,
  selectedRole,
  onRoleChange,
}) => {
  const [newRole, setNewRole] = useState<string>(selectedRole);
  const Roles=[{key:"Super Admin",value:"Super Admin"}
    ,{key:"Leader", value:"Compliance_Leader"}
    ,{key:"Manger", value:"Compliance_Manager"}
    ,{key:"Implementer", value:"Compliance_Implementer"}
    ,{key:"Supervisor", value:"Compliance_Supervisor"}]

  // Sync `newRole` with `selectedRole` whenever the modal opens or selectedRole changes
  useEffect(() => {
    if (isOpen) {
      setNewRole(selectedRole);
    }
  }, [isOpen, selectedRole]);

  const handleSave = () => {
    if (newRole) {
      onRoleChange(newRole); // Call the parent handler with the updated role
      toggle(); // Close the modal
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader  style={{ direction: 'ltr', paddingRight: '10px' }}
       toggle={toggle}>{t("Update Role")}
      </ModalHeader>
      <ModalBody>
        <select
          value={newRole}
          onChange={(e) => setNewRole(e.target.value)}
          className="form-control"
        >
          {Roles.map((role) => (
            <option key={role.value} value={role.value}>
              {role.key}
            </option>
          ))}
        </select>
      </ModalBody>
      <ModalFooter>
      <button
      type="submit"
      className="mx-3 btnSubmit" onClick={handleSave}>
        {t("Save")}
        </button>
        <button
      type="button"
      className="btn btn-gray btn-cancle rounded"
    
         onClick={toggle}>
        {t("Cancel")}

        </button>
      </ModalFooter>
    </Modal>
  );
};